var map = {
	"./banner.webp": "15c9",
	"./banner2.webp": "48a8",
	"./banner3.webp": "da8b",
	"./banner4.webp": "3410",
	"./branches-bg.webp": "4bfa",
	"./contact.webp": "3d46",
	"./delivery.webp": "b2fa",
	"./logo.webp": "4841",
	"./menu-bg2.webp": "0a50",
	"./menu-cont-bg.webp": "ca9d",
	"./menu_result.webp": "6e91"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";